/**
 * Labstep
 *
 * @module components/Permission/Action/Create
 * @desc Action to create a permission
 */

import { PermissionSelectGroupContainer as PermissionSelectGroup } from 'labstep-web/components/Permission/Select/Group';
import { PermissionMenu } from 'labstep-web/core/Permission';
import { Group } from 'labstep-web/models/group.model';
import { PermissionType } from 'labstep-web/models/permission.model';
import { getHumanReadableEntityName } from 'labstep-web/services/i18n.service';
import React from 'react';
import styles from './styles.module.scss';
import type {
  HandleChangeProps,
  PermissionActionCreateProps,
  PermissionActionCreateState,
} from './types';

export class PermissionActionCreate extends React.Component<
  PermissionActionCreateProps,
  PermissionActionCreateState
> {
  constructor(props: PermissionActionCreateProps) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.state = { groupPermission: PermissionType.view };
  }

  handleChange({ type }: HandleChangeProps) {
    this.setState({ groupPermission: type });
  }

  render() {
    const { parentEntity } = this.props;
    const { groupPermission } = this.state;

    return (
      <div>
        <div>
          <span>
            {`Share with ${getHumanReadableEntityName(Group.entityName, true, true)}`}
          </span>
        </div>
        <div className={styles.addContainer}>
          <PermissionSelectGroup
            parentEntity={parentEntity}
            type={groupPermission}
          />
          <div>
            <PermissionMenu
              type={groupPermission as any}
              onClick={this.handleChange}
            />
          </div>
        </div>
      </div>
    );
  }
}
